import React from 'react'
import SvgIcon from './SvgIcon'

export default SvgIcon(
  <svg viewBox="0 0 23 23">
    <rect x="6.3" y="6.3" style={{stroke: '#6AAEAA', strokeWidth: '0px', fill: '#6AAEAA', fillOpacity: 1}} id="chx_rectangle_red" width="10.4" height="10.4"/>
    <rect x="0" y="0" style={{stroke: '#464646', strokeWidth: '4px', fill: 'white', fillOpacity: 0}} id="chx_rectangle" width="23" height="23"/>
  </svg>
)